window.addEventListener('load', function() {
    setTimeout(function() {
      var instaLinks = document.querySelectorAll('.instafeed-fullname');

      instaLinks.forEach(function(link, index) {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');

        var currentHref = link.getAttribute('href');
        if (currentHref && !currentHref.includes('ref=text')) {
          var separator = currentHref.includes('?') ? '&' : '?';
          link.setAttribute('href', currentHref + separator + 'ref=text-' + index);
        }
      });

      var honeypotInput = document.querySelector('.mrbp-form input[name="website"]');
      if (honeypotInput && !honeypotInput.hasAttribute('aria-label')) {
        honeypotInput.setAttribute('aria-label', 'Website');
      }

    }, 2500);
});

/* ===== Mr. Boddington's Studio custom sign-up pop-up loader =====
   Fetches the popup script hosted in Shopify Files and injects it.
   To disable the popup, delete everything below this line. */
(function(){
  try {
    fetch('https://cdn.shopify.com/s/files/1/0678/6724/6836/files/mrb-popup-v3.js?v=1784903351')
      .then(function(r){ return r.text(); })
      .then(function(t){ var s=document.createElement('script'); s.textContent=t; (document.head||document.documentElement).appendChild(s); })
      .catch(function(e){ console.warn('MRB popup load failed', e); });
  } catch(e) { console.warn('MRB popup loader error', e); }
})();
